import { render, staticRenderFns } from "./guHuai.vue?vue&type=template&id=22cb38b6&scoped=true"
import script from "./guHuai.vue?vue&type=script&lang=js"
export * from "./guHuai.vue?vue&type=script&lang=js"
import style0 from "./guHuai.vue?vue&type=style&index=0&id=22cb38b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22cb38b6",
  null
  
)

export default component.exports